import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import HttpApi, { HttpBackendOptions } from 'i18next-http-backend'

import TempLocale from '@/assets/locale/temp.json'

class MyHttpApi extends HttpApi {
  // 重写loadUrl方法，将temp.json的内容添加到语言包中
  loadUrl(
    url: string,
    callback: any,
    languages?: string | string[],
    namespaces?: string | string[]
  ): void {
    const myCallback = (error: any, data: any) => {
      if (data?.['@lang_key'] === Locale.US) {
        data = Object.assign({}, TempLocale, data)
      }
      callback(error, data)
    }
    super.loadUrl(url, myCallback, languages, namespaces)
  }
}

export enum Locale {
  US = 'en-US',
  KR = 'ko-KR',
  TW = 'zh-TW'
}

export const languages = [
  {
    name: 'English',
    locale: Locale.US
  }
  // {
  //   name: '한국어',
  //   locale: Locale.KR
  // },
  // {
  //   name: '繁體中文',
  //   locale: Locale.TW
  // }
]

i18n
  // .use(HttpApi)
  .use(MyHttpApi)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init<HttpBackendOptions>({
    backend: {
      loadPath: '/locales/{{lng}}.json'
    },
    lng: Locale.US,
    fallbackLng: Locale.US,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      caches: ['localStorage', 'sessionStorage', 'cookie']
    }
  })

const defalutLocale = (localStorage.getItem('locale') as Locale) || Locale.US

export const refreshLocale = (locale: Locale) => {
  localStorage.setItem('locale', locale)
  document.documentElement.lang = locale
}

i18n.on('languageChanged', (lng) => {
  refreshLocale(lng as Locale)
})

i18n.changeLanguage(defalutLocale)

export default i18n
